module.exports = __webpack_public_path__ + "static/media/red-x.7465f4a4.svg";